import React from 'react';
import styles from './index.module.scss';

import If from 'utils/If';
import UiKit from 'components/UiKit';
import useStore from 'utils/hooks/useStore';

export default function CustomerSupport({ className = '' }) {
  const { getStoreProperty } = useStore();

  const phone = getStoreProperty('retailer_phone', '');
  const email = getStoreProperty('store_support_email', '');

  if (!phone && !email) {
    return null;
  }

  return (
    <UiKit.Flex gap={16} align="center" justify="center" className={className}>
      <UiKit.Text tone="muted" className={styles.content}>
        <span className={styles.label}>Contact Support</span>
        <UiKit.Separator.Dot className={styles.dot} />
        <If test={email}>
          <a href={`mailto:${email}`}>
            <UiKit.Text type="span" tone="muted">
              {email}
            </UiKit.Text>
          </a>
        </If>
        <If test={phone}>
          <UiKit.Separator.Dot className={styles.dot} />
          <a href={`tel:${phone}`}>
            <UiKit.Text type="span" tone="muted">
              {phone}
            </UiKit.Text>
          </a>
        </If>
      </UiKit.Text>
    </UiKit.Flex>
  );
}
